import React from "react";
import cx from "classnames";
import s from "./radioButton.scss";

export default class RadioButton extends React.Component {
  onChange(e) {
    if (!this.props.onChange) return;

    this.props.onChange({ [this.props.name]: e.target.value });
  }

  render() {
    let { className, radioClassName, children, id, name, grouplabel, inRow = false, value, disabled } = this.props;

    return (
      <div
        id={id}
        className={cx(className, s.radioGroup, {
          [s.childreninrow]: inRow,
        })}
      >
        {grouplabel && <div className={s.groupLabel}>{grouplabel}</div>}
        <div className={s.radioChildren}>
          {children.map((child, i) => (
            <div
              className={cx(radioClassName, s.radioBtn, {
                [s.disabled]: child.disabled || disabled,
                [s.best]: child.bestLabel,
              })}
              key={name + i.toString()}
            >
              <input
                className={s.radioInput}
                type="radio"
                id={name + i.toString()}
                value={child.value}
                name={name}
                checked={child.value === value ? true : false}
                onChange={this.onChange.bind(this)}
                disabled={child.disabled || disabled}
              />

              {child.label && (
                <div className={s.wrapLabel}>
                  <label className={s.radioLabel} htmlFor={name + i.toString()}>
                    {child.label}
                    {child.bestLabel && <span className={s.bestLabel}>{child.bestLabel}</span>}
                  </label>
                  {child.description && <div className={s.description}>{child.description}</div>}
                </div>
              )}
            </div>
          ))}
        </div>
      </div>
    );
  }
}
